import React, {useEffect, useState} from 'react';
import {KnowledgeTestType} from '../../../hooks/apis/useKnowledgeTest';
import {Button, Card, Col, Divider, Modal, Row, Space, Tag} from 'antd';
import Flex from '../../../components/Flex';
import Title from 'antd/lib/typography/Title';
import Text from 'antd/lib/typography/Text';
import UseKnowledgeSubmission, {IKnowledgeSubmission, IKnowledgeSubmissionQuestion} from '../../../hooks/apis/useKnowledgeSubmission';
import {useArray} from 'react-hanger';
import KnowledgeQuestionSubmitItem from '../../../components/KnowledgeQuestion/SubmitItem';
import Countdown from 'antd/lib/statistic/Countdown';
import {KnowledgeQuestionType} from '../../../hooks/apis/useKnowledgeBank';
import Paragraph from 'antd/lib/typography/Paragraph';
import QuickRouter from '../../../utils/QuickRouter';
import useAuth from '../../../utils/AuthContext';
import {useParams} from 'react-router-dom';
import CommonApiErrorHandler from '../../../utils/HttpInstance';
import useQuickRouter from '../../../utils/QuickRouter';

export default function KnowledgeSubmissionResultPage() {
  const auth = useAuth();
  const querySubmissionState = UseKnowledgeSubmission.queryById();
  const params = useParams() as {id?: string};
  const submissionId = parseInt(params?.id || '');
  const [submission, setSubmission] = useState<IKnowledgeSubmission>();
  const questions = submission ? submission.knowledgeSubmissionQuestions : [];
  const [currentQuestion, setCurrentQuestion] = useState<IKnowledgeSubmissionQuestion>();
  const quickRouter = useQuickRouter();

  function refresh() {
    querySubmissionState
      .request({id: submissionId})
      .then(res => {
        setSubmission(res);
        setCurrentQuestion(res.knowledgeSubmissionQuestions[0]);
      })
      .catch(CommonApiErrorHandler);
  }

  async function nextQuestion() {
    if (!currentQuestion) throw new Error('currentQuestion not found');
    if (!submission) throw new Error('submission not found');
    const currentIndex = submission.knowledgeSubmissionQuestions.findIndex(i => i.id === currentQuestion.id) || 0;
    const next = submission.knowledgeSubmissionQuestions[currentIndex + 1];
    if (next) setCurrentQuestion(next);
  }

  async function preQuestion() {
    if (!currentQuestion) throw new Error('currentQuestion not found');
    if (!submission) throw new Error('submission not found');
    const currentIndex = submission.knowledgeSubmissionQuestions.findIndex(i => i.id === currentQuestion.id) || 0;
    const pre = submission.knowledgeSubmissionQuestions[currentIndex - 1];
    if (pre) setCurrentQuestion(pre);
  }

  useEffect(() => {
    refresh();
  }, [auth.currentUser]);

  function renderQuestionBtn(question: IKnowledgeSubmissionQuestion) {
    return (
      <Col span={3} key={question.id}>
        <Tag
          onClick={() => {
            setCurrentQuestion(question);
          }}
          color={question.score !== question.scoreGet ? 'error' : undefined}
          style={{width: 55, marginBottom: 5, textAlign: 'center', cursor: 'pointer'}}>
          第{question.index}题
        </Tag>
      </Col>
    );
  }

  return (
    <Flex justify={'center'}>
      <div style={{width: 700}}>
        {submission && (
          <Card
            style={{width: 700}}
            title={'查看成绩'}
            extra={
              <Space>
                <Button type={'primary'} onClick={() => quickRouter.knowledgeTestHistory(submission?.testId, submission?.submitterId)}>
                  查看历史统计
                </Button>
              </Space>
            }>
            <Flex direction={'column'} align={'center'}>
              <Title level={5}>{submission.test.contest.name}</Title>
              <Title level={3} style={{marginBottom: 0, marginTop: 0}}>
                {KnowledgeTestType[submission.test.type]}
              </Title>
              <Divider />
              <div style={{textAlign: 'center', width: 500}}>
                <div>
                  <Text strong>此次答题成绩为：{submission.scoreGet} 分</Text>
                </div>
                <Text type={'secondary'}>红色为答错题</Text>
                <h3 className={'mt-md'}>单选题</h3>
                <Row>{questions.filter(q => q.type === KnowledgeQuestionType.单选题).map(q => renderQuestionBtn(q))}</Row>
                <h3 style={{marginTop: 20}}>多选题</h3>
                <Row>{questions.filter(q => q.type === KnowledgeQuestionType.多选题).map(q => renderQuestionBtn(q))}</Row>
              </div>
              {currentQuestion && <KnowledgeQuestionSubmitItem question={currentQuestion} showResult />}
              <Divider />
              <Space>
                <Button onClick={preQuestion} disabled={questions.findIndex(i => i.id === currentQuestion?.id) === 0}>
                  上一题
                </Button>
                <Button onClick={nextQuestion} disabled={questions.findIndex(i => i.id === currentQuestion?.id) === questions.length - 1}>
                  下一题
                </Button>
              </Space>
            </Flex>
          </Card>
        )}
      </div>
    </Flex>
  );
}
